import { useLogisticaConfiguration, withLogisticaConfiguration } from "./configurazione/LogisticaConfigurationProvider";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import ModificaOrdini from "./AreaOrdiniComponenti/ModificaOrdini";
import ModificaGaranzie from "./AreaOrdiniComponenti/ModificaGaranzie.js";
import AreaOrdiniNOORDINE from "./AreaOrdiniNOORDINE";
import CreaGaranzie from "./CreaGaranzie.js";

function AreaOrdiniMID({
  utente,
  ordine,
  setOrdine,
  ricercaIniz,
  tema,
  urlRicerca,
  setUrlRicerca,
  perPage,
  setPerPage,
  page,
  setPage,
  totalRows,
  setTotalRows,
  vista,
  columnSort,
  setColumnSort,
  directionSort,
  setDirectionSort,
  inputVuoto,
  colonna,
  titolo,
  urlParametri,
  setUrlParametri,
  ricerca,
  setRicerca,
  inputIniziale,
  setInputIniziale,
  setVista,
  urlRicercaINIT,
  mobile,
}) {
  const { datiTendineOrdine } = useLogisticaConfiguration();

  const [resImport, setResImport] = useState("");
  const [garanzia, setGaranzia] = useState(false);
  const [nuovaGaranzia, setNuovaGaranzia] = useState(false);
  const [listeOrdiniDaAltrove, setListeOrdiniDaAltrove] = useState(false);
  const [listaId, setListaId] = useState(false);
  const [indexOrdine, setIndexOrdine] = useState(false);

  const setVistaConReset = function (e, vista, url, perPage) {
    const ricercaResetBase = {
      ...ricercaIniz,
      columnSort: "",
      directionSort: "",
    };
    const ricercaReset =
      vista === "note"
        ? { ...ricercaResetBase, includeNote: "1" }
        : ricercaResetBase;
    setListeOrdiniDaAltrove(false);
    setColumnSort(undefined);
    setDirectionSort(undefined);
    setUrlParametri(false);
    setInputIniziale(ricercaReset);
    setRicerca(ricercaReset);
    setPage(1);
    setPerPage(perPage);
    setUrlRicerca(url);
    setVista(vista);
  };

  const areaOrdini = function (
    perPageOptionsArg,
    vistaArea,
    listaOrdiniDaAltrove,
    perPaginaForzato,
    funzioneScegliID
  ) {
    let perPagina = perPage;
    if (mobile) {
      perPagina = 9;
    } else if (perPaginaForzato) {
      perPagina = perPaginaForzato;
    }

    return (
      <AreaOrdiniNOORDINE
        mobile={mobile}
        utente={utente}
        ordine={ordine}
        setOrdine={setOrdine}
        ricercaIniz={ricercaIniz}
        tema={tema}
        urlRicerca={urlRicerca}
        setUrlRicerca={setUrlRicerca}
        perPage={perPagina}
        perPageOptions={perPageOptionsArg}
        setPerPage={setPerPage}
        page={page}
        setPage={setPage}
        totalRows={totalRows}
        setTotalRows={setTotalRows}
        vista={vistaArea}
        columnSort={columnSort}
        setColumnSort={setColumnSort}
        directionSort={directionSort}
        setDirectionSort={setDirectionSort}
        inputVuoto={inputVuoto}
        urlParametri={urlParametri}
        setUrlParametri={setUrlParametri}
        ricerca={ricerca}
        setRicerca={setRicerca}
        inputIniziale={inputIniziale}
        setInputIniziale={setInputIniziale}
        colonna={colonna}
        setVista={setVista}
        urlRicercaINIT={urlRicercaINIT}
        setGaranzia={setGaranzia}
        setNuovaGaranzia={setNuovaGaranzia}
        listaOrdiniDaAltrove={listaOrdiniDaAltrove}
        setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
        funzioneScegliID={funzioneScegliID}
        setVistaConReset={setVistaConReset}
        setListaId={setListaId}
      />
    );
  };

  return (
    <div className="center">
      {/* desktop */}
      <div className="cf ">
        {((ordine === "NO DATA" && !garanzia && !nuovaGaranzia) ||
          (colonna && colonna !== "1")) && (
          <div className="sfondoBiancoTema">
            {titolo && (
              <div className="tc f5 b sfondoColChiaro pa3 ttu">{titolo}</div>
            )}
            {!mobile && areaOrdini([10, 15, 50, 200], vista)}
            {mobile && areaOrdini([9, 10, 200], vista)}
          </div>
        )}
        <div className="fl w-100 w-100-ns">
          <div className="sfondoBiancoTema">
            {garanzia && (
              <ModificaGaranzie
                garanzia={garanzia}
                setGaranzia={setGaranzia}
                utente={utente}
                datiTendineOrdine={datiTendineOrdine}
                setOrdineFunction={setOrdine}
                setVistaConReset={setVistaConReset}
              />
            )}
            {nuovaGaranzia && (
              <CreaGaranzie
                setGaranzia={setGaranzia}
                setNuovaGaranzia={setNuovaGaranzia}
                utente={utente}
                areaOrdini={areaOrdini}
                setTotalRows={setTotalRows}
                setRicerca={setRicerca}
                setUrlRicerca={setUrlRicerca}
                setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
                setVistaConReset={setVistaConReset}
              />
            )}

            {ordine !== "NO DATA" && !colonna && (
              <ModificaOrdini
                ordine={ordine}
                setOrdineFunction={setOrdine}
                utente={utente}
                setResImport={setResImport}
                resImport={resImport}
                datiTendineOrdine={datiTendineOrdine}
                setVistaConReset={setVistaConReset}
                listaId={listaId}
                indexOrdine={indexOrdine}
                setIndexOrdine={setIndexOrdine}
                page={page}
                perPage={perPage}
                ricerca={ricerca}
                columnSort={columnSort}
                directionSort={directionSort}
                urlRicerca={urlRicerca || urlRicercaINIT}
                vista={vista}
              />
            )}
            {ordine !== "NO DATA" && (colonna || vista === "garanzie") && (
              <div>
                {createPortal(
                  <div id="modal-root">
                    <div className="modal"></div>
                  </div>,
                  document.body
                )}
                {createPortal(
                  <div id="modal-content" className="rootTema">
                    <div className={tema + " ordinePopUp"}>
                      <ModificaOrdini
                        ordine={ordine}
                        setOrdineFunction={setOrdine}
                        utente={utente}
                        setResImport={setResImport}
                        resImport={resImport}
                        datiTendineOrdine={datiTendineOrdine}
                        popUp={true}
                        mobile={mobile}
                        setVistaConReset={setVistaConReset}
                      />
                    </div>
                  </div>,
                  document.body
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withLogisticaConfiguration(AreaOrdiniMID);
